import comp from "./CreateJob";
export default comp;
